import { render, staticRenderFns } from "./TheLogo.vue?vue&type=template&id=117a9e60"
import script from "./TheLogo.vue?vue&type=script&lang=js"
export * from "./TheLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports